import Button from 'components/Button';
import renderField from 'components/Field/reduxForm';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import Purify from 'dompurify';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form/immutable';
import submitFunc from './submitResetPassword';
import { numberOnly } from '../../../../../utils/reduxForm/inputFilters';

const formName = 'rstPwd';
const innMaxLength = 12;
const select = formValueSelector(formName);

@connect((state) => ({
  email: select(state, 'email'),
}))
class ResetPasswordForm extends React.Component {
  static propTypes = {
    email: PropTypes.string.isRequired,
    error: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitSucceeded: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    invalid: PropTypes.bool.isRequired,
    showInfoMessage: PropTypes.func.isRequired,
  };

  componentDidUpdate() {
    const { submitSucceeded, showInfoMessage, email } = this.props;
    if (submitSucceeded) {
      showInfoMessage(`Ссылка для восстановления пароля отправлена на электронную почту ${email}`);
    }
  }

  render() {
    const { handleSubmit, submitting, invalid, error } = this.props;
    const safeError = Purify.sanitize(error);

    return (
      <div>
        {invalid ? (
          <div className="popup_message popup_message__visible js-block">
            <div className="link link_attention-red">
              Внимание! Вам предоставляется три попытки ввода реквизитов. В случае превышения
              допустимого количества попыток возможность восстановления пароля будет заблокирована
              на сутки.
            </div>
          </div>
        ) : null}

        <form onSubmit={handleSubmit} className="form">
          {/* back-end returns error with HTML tags */}
          {/* eslint-disable-next-line react/no-danger */}
          {error ? <p className="red" dangerouslySetInnerHTML={{ __html: safeError }} /> : null}
          <div className="cRow form_row">
            <div className="cCol cCol__33">
              <Field
                name="inn"
                component={renderField}
                label="ИНН*"
                maxLength={innMaxLength}
                normalize={numberOnly}
                placeholder="000000000000"
              />
            </div>
            <div className="cCol cCol__33">
              <Field
                name="email"
                component={renderField}
                label="Адрес электронной почты*"
                placeholder="email@domain.com"
              />
            </div>
            <div className="cCol cCol__33">
              <Field
                name="codeWord"
                component={renderField}
                label="Контрольное слово*"
                placeholder="Мое контрольное слово"
              />
            </div>
          </div>
          <div className="cRow cRow__tablet">
            <div className="cCol">
              <div className="form_item">
                <Button isDisabled={submitting} onClick={noop} type="submit">
                  Восстановить пароль
                </Button>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: formName,
  onSubmit: submitFunc,
})(ResetPasswordForm);
